import type { UserType } from "@ip-contexts/user-context";

export function hasPermission(
  user: UserType,
  audience: string,
  scopes: string[]
) {
  return scopes.every((scope) => user.roles[audience]?.includes(scope));
}
